<gd-header-create-menu-stateless
  *ngIf="!(isGelatoUser$ | async)"
  [isMobile]="isMobile"
  (placeOrder)="placeOrder()"
  (addNewProduct)="addNewProduct()"
>
</gd-header-create-menu-stateless>
